export const getAvatarLink = (fullLink: string): string => {
  const link = fullLink.split("/");
  const fileName = link[link.length - 1];
  return `${process.env.VUE_APP_API_URL}images/${fileName}`;
};
